import DropdownSheet from 'components/Luxkit/Dropdown/Sheet/DropdownSheet'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { ComponentProps, useCallback, useContext, useRef } from 'react'
import OfferDatePicker from './OfferDatePicker'
import OfferDatePickerSelectBox from './OfferDatePickerSelectBox'

interface Props extends Pick<ComponentProps<typeof DropdownSheet>, 'open' | 'boundaryRef'> {}

function OfferDatePickerSelect(props: Props) {
  const { open, boundaryRef } = props
  const dispatch = useOfferPageDispatch()
  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)

  const onCloseCross = useCallback(() => {
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.CloseFilter, CALENDAR_GA_EVENT_LABEL.CloseCross)
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch, onUserAnalyticsAction])

  const onApply = useCallback(() => {
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.Apply)
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch, onUserAnalyticsAction])

  const triggerRef = useRef<HTMLButtonElement>(null)

  return <div>
    <OfferDatePickerSelectBox ref={triggerRef} />
    <DropdownSheet
      size="L"
      anchorRef={triggerRef}
      triggerRef={triggerRef}
      boundaryRef={boundaryRef}
      onClose={onCloseCross}
      open={open}
      data-testid="OfferDatePickerSelect"
      primaryActionProps={{
        'data-testid': 'OfferDatePickerSelect-apply',
        children: 'Apply',
        onClick: onApply,
      }}
    >
      <OfferDatePicker />
    </DropdownSheet>
  </div>
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'checkin',
}))(OfferDatePickerSelect)
